import { Link } from 'react-router-dom'
import TV from '../../components/TV'
import landing from '../../data/landing'
import './index.scss'

const NewHome = () => {
  const {
    initials,
    name,
    tagline,
    nav,
    blurb,
    blurbMobile,
    taglineMobile,
    para,
    badge,
    iframeSrc,
  } = landing

  return (
    <div className='nh-root'>
      {/* ── DESKTOP ONLY ───────────────────────────────────── */}

      <div className='nh-name nh-name--tl nh-desktop-only' aria-hidden='true'>
        <div>{name.line1}</div>
        <div>{name.line2}</div>
      </div>

      <div className='nh-name nh-name--br nh-desktop-only' aria-hidden='true'>
        <div>{name.line1}</div>
        <div>{name.line2}</div>
      </div>

      <div className='nh-blurb nh-desktop-only'>{blurb}</div>

      <div className='nh-para nh-desktop-only'>
        <div className='nh-eyebrow'>( {tagline} )</div>
        <p className='nh-body'>{para}</p>
      </div>

      {/* ── MOBILE ONLY ────────────────────────────────────── */}

      <div className='nh-topbar nh-mobile-only'>
        <div className='nh-pill nh-pill--logo'>{initials}</div>
        <Link to='/contact' className='nh-pill nh-pill--active'>
          Contact
        </Link>
      </div>

      <div className='nh-eyebrow-top nh-mobile-only'>
        <div className='nh-eyebrow'>( {tagline} )</div>
        <p className='nh-eyebrow-body'>{taglineMobile}</p>
      </div>

      <div className='nh-name-vertical nh-mobile-only' aria-hidden='true'>
        <div className='nh-name-vertical__word nh-name-vertical__word--1'>{name.line1}</div>
        <div className='nh-name-vertical__word nh-name-vertical__word--2'>{name.line2}</div>
      </div>

      <div className='nh-blurb-bottom nh-mobile-only'>{blurbMobile}</div>

      <nav className='nh-bottom-tabs nh-mobile-only'>
        {nav.map(({ label, to }, i) => (
          <Link key={to} to={to} className={`nh-tab${i === 0 ? ' nh-tab--active' : ''}`}>
            {label}
          </Link>
        ))}
        <Link to='/contact' className='nh-tab'>
          Contact
        </Link>
      </nav>

      {/* ── SHARED ─────────────────────────────────────────── */}

      <div className='nh-hero-wrap'>
        <div className='nh-hero-drift'>
          <TV iframeSrc={iframeSrc} />
        </div>
      </div>

      <Link to={badge.link || '/'} className='nh-badge'>
        <div className='nh-badge__dot' />
        <div className='nh-badge__title'>
          {badge.title.split('\n').map((l, i) => (
            <span key={i}>
              {l}
              {i === 0 && <br />}
            </span>
          ))}
        </div>
        <div className='nh-badge__sub'>{badge.sub}</div>
      </Link>
    </div>
  )
}

export default NewHome
